import "./SignUpPage.css"
import { useContext, useRef, useState} from "react"
import { auth, db } from "../../../Lib/Firebase/Firebase"
import { Link, useHistory } from "react-router-dom"
import { pageWrapper } from "../../App/App";
import { ACTIONS } from "../../../bin/reducerState/reducerState";
import UserInput from "../../UserInput/UserInput";
import { Footer } from "../../Footer/Footer";

const SignUpPage = () => {

  

  
  let stateObj = useContext(pageWrapper)

  // tell the user if he has an incorrect value with a p tag
  let [showIncorrectName,setShowIncorrectName] = useState("")
  let [showIncorrectPostCode,setShowIncorrectPostcode] = useState("")
  let [showIncorrectNumber,setShowIncorrectNumber] = useState("")
  let [showIncorrectAddress,setShowIncorrectAddress] = useState("")
  let [showIncorrectPassword,setShowIncorrectPassword] = useState("")
  
  // refrence of all the inputs
  const nameRef= useRef("")
  const postcodeRef = useRef("")
  const telPhoneRef = useRef("");
  const AddresRef = useRef("")
  const emailRef = useRef("")
  const PasswordRef = useRef("")

  
  let history = useHistory();


  function signUp(Data){
    
    auth.createUserWithEmailAndPassword(
      emailRef.current.value,
      PasswordRef.current.value
    ).then(User=>{
     
      // set the insitial state of the user's id
      stateObj.dispatch({type:ACTIONS.SET_USERID,payload:User.user.uid})

      // send to firebase all the correct info after it's checked 
      db.child(User.user.uid).set({
        postcode:postcodeRef.current.value,
        lati:Data.result.latitude,
        longi:Data.result.longitude,
        displayName:nameRef.current.value,
        PhoneNumber:telPhoneRef.current.value,
        bookingStatus:"none",
        Address:AddresRef.current.value
        
      })
      history.push("/Booking");

    }).catch(err=>{
      setShowIncorrectPassword(`${err.message}`)
        
    })
  }




  async function fetchPostCodeApi(){
    
      const Response = await fetch(`https://api.postcodes.io/postcodes/${postcodeRef.current.value}`)

      if (Response.status === 200) {
        const Data = await Response.json()
        signUp(Data)
        setShowIncorrectPostcode("")
      }else{
        postcodeRef.current.value=""
        setShowIncorrectPostcode("incorrect postcode, full postcode only!")
      }
    
  }
// STEP 1️⃣
  function checkAllConditionsAreMet(e) {
    e.preventDefault()
    // check users name is  more then 2 characters else tell the user
    if(nameRef.current.value.length>2){
      setShowIncorrectName("")
      // check users number is 11 characters else tell the user
      if(telPhoneRef.current.value.length===11){
        setShowIncorrectNumber("")
        // check users address contains a house number else tell the user
        if((/[(0-9)]/).test(AddresRef.current.value) ){
          setShowIncorrectAddress("")
          // now fetch and check there postcode
          fetchPostCodeApi()
        }else{
          setShowIncorrectAddress("Address must contain a house Number")
        }
      }else{
        setShowIncorrectNumber("incorrect phone number, 11 digits only")
      }
    }else{
      setShowIncorrectName("name has to be longer then 2 character")
    }
  }


  return ( 
    <div className="SignUp">

      

      <form className="SignUp__Form">

          <h1 className="SignUp__Form-title">Sign up</h1>

          <div className="SignUp__UserInfo">


            <UserInput title={"Full Name"}
            inputRef={nameRef}
            value={nameRef.current.value}
            incorrectValue={showIncorrectName}
            type={"text"}
            />
      
            <UserInput title={"Postcode"}
            inputRef={postcodeRef}
            value={postcodeRef.current.value}
            incorrectValue={showIncorrectPostCode}
            type={"text"}
            />

            <UserInput title={"Phone Number"}
            inputRef={telPhoneRef}
            value={telPhoneRef.current.value}
            incorrectValue={showIncorrectNumber}
            type={"text"}
            />

            <UserInput title={"Home Address - bike pickup location"}
            inputRef={AddresRef}
            value={AddresRef.current.value}
            incorrectValue={showIncorrectAddress}
            type={"text"}
            />

            <UserInput title={"Email"}
            inputRef={emailRef}
            value={emailRef.current.value}
            incorrectValue={""}
            type={"text"}
            />

            <UserInput title={"Password"}
            inputRef={PasswordRef}
            value={PasswordRef.current.value}
            incorrectValue={showIncorrectPassword}
            type={"password"}
            />

          </div>

          <button 
          onClick={(e)=>checkAllConditionsAreMet(e)}
          className="signUp">
            Sign up
          </button>

        <h2>
          Allready have an account ? <Link style={{textDecorationLine:"underline"}} to="SignIn">Sign In</Link> 
        </h2>
        <Footer/> 

        </form>

    </div>
   );
}
 
export default SignUpPage;
